import { Platform } from 'react-native';
import { proxy } from '../../../../globalVars/data';

export const getStationInfo = async (
  id: string,
  filterType: 'lock' | 'unlock',
) => {
  const requestOptions: RequestInit = {
    method: 'GET',
    redirect: 'follow',
  };

  const urlWeb = proxy + `http://200.234.207.52:8000/stations/${id}`;
  const urlNative = `http://200.234.207.52:8000/stations/${id}`;

  const condNative = Platform.OS === 'web' ? urlWeb : urlNative;
  console.log({ condNative });

  console.log({ requestOptions });

  try {
    const response = await fetch(condNative, requestOptions);

    // Se não for sucesso (2xx), retorna valores padrão
    if (!response.ok) {
      console.log('RES API BIKES ERROR', {
        status: response.status,
        statusText: response.statusText,
      });
      return { numBikes: '0', foundBikes: [] };
    }

    let json;
    try {
      json = await response.json();
    } catch (parseError) {
      console.log('RES API BIKES ERROR - JSON Parse failed:', parseError);
      return { numBikes: '0', foundBikes: [] };
    }

    console.log('station info', { json });

    // Novo cálculo: contar apenas racks com status 'lock'
    const racks = Array.isArray(json?.msg?.racks) ? json.msg.racks : [];
    const foundBikes = racks.filter((rack: any) => rack?.status === filterType);
    console.log('RES API BIKES OK', { filterType, foundBikes });

    return { numBikes: String(foundBikes.length), foundBikes };
  } catch (error) {
    console.log('RES API BIKES ERROR - Exception:', error);
    return { numBikes: '0', foundBikes: [] };
  }
};
